angular.module("ainapp")
    .controller("BulkCostCenterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Bulk Cost Center";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Init = function () {

                $scope.Products = [];

                $scope.Costs = [];
                MainService.GetParentCostCenters().then(function (response) {
                    $scope.Costs = response.data;
                })

                $scope.filter = {
                    CostId: "",
                }

            }
            $scope.Init();


            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);
                        //.replace(/-/g, "/");
                        angular.forEach(oJS, function (e) {
                            e.Name = e.Name;
                            e.Code = e.Code;
                            e.Description = e.Description;
                            e.Level = 2;
                            e.ParentId = "";
                            e.Address = e.Address;
                            e.Field1 = e.Field1;
                            e.Field2 = e.Field2;
                            e.Field3 = e.Field3;
                            e.Field4 = e.Field4;
                            e.Field5 = e.Field5;
                            e.Field6 = e.Field6;
                            e.Field7 = e.Field7;
                            e.Field8 = e.Field8;
                            e.Field9 = e.Field9;
                            e.Field10 = e.Field10;
                            e.Field11 = e.Field11;
                            e.Field12 = e.Field12;
                            e.Field13 = e.Field13;
                            e.Field14 = e.Field14;
                            e.Field15 = e.Field15;
                            if (e.Field16 != null && e.Field16 != undefined && e.Field16 != "") {
                                e.Field16 = new Date(e.Field16);
                            }
                            if (e.Field17 != null && e.Field17 != undefined && e.Field17 != "") {
                                e.Field17 = new Date(e.Field17);
                            }
                            if (e.Field18 != null && e.Field18 != undefined && e.Field18 != "") {
                                e.Field18 = new Date(e.Field18);
                            }
                            if (e.Field19 != null && e.Field19 != undefined && e.Field19 != "") {
                                e.Field19 = new Date(e.Field19);
                            }
                            if (e.Field20 != null && e.Field20 != undefined && e.Field20 != "") {
                                e.Field20 = new Date(e.Field20);
                            }
                        });

                        $scope.Products = oJS;
                        $scope.$apply();
                    });
                };

                reader.readAsBinaryString(oFile);
            }

            $scope.applyparent = function () {
                angular.forEach($scope.Products, function (e) {
                    e.ParentId = $scope.filter.CostId;
                })
            }


            $scope.uploadProducts = function () {

                var temp = 0;
                angular.forEach($scope.Products, function (e) {

                    if (e.Name == null || e.Name == "" || e.Name == undefined || e.ParentId == "") {
                        temp = 1;
                    }

                })

                if (temp == 1) {
                    toastr.warning("Invalid Format, Name and parent needed in all rows. ");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.AddBulkCostCenter($scope.Products).then(function (response) {
                        if (response.data == 1) {
                            toastr.success("Success");
                            $scope.Init();
                        } else {
                            toastr.warning("Failed ");
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error("Network Error");
                        $.LoadingOverlay("hide");
                    })
                }


            }



        }])
